/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetWidgetSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetWidgetRequest = {
  /**
   * The widget to get
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetWidgetSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetWidgetSecurity$outboundSchema: z.ZodMiniType<
  GetWidgetSecurity$Outbound,
  GetWidgetSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getWidgetSecurityToJSON(
  getWidgetSecurity: GetWidgetSecurity,
): string {
  return JSON.stringify(
    GetWidgetSecurity$outboundSchema.parse(getWidgetSecurity),
  );
}

/** @internal */
export type GetWidgetRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetWidgetRequest$outboundSchema: z.ZodMiniType<
  GetWidgetRequest$Outbound,
  GetWidgetRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getWidgetRequestToJSON(
  getWidgetRequest: GetWidgetRequest,
): string {
  return JSON.stringify(
    GetWidgetRequest$outboundSchema.parse(getWidgetRequest),
  );
}
